export const TICKET = 'TICKETADMIN'